import React from "react";
import { useMutation } from "@apollo/client";
import { Link } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { AddSourceValidationSchema } from "pages/SourcePage/SourceValidationSchema";
import client from "client";
import { CREATE_SOURCE } from "pages/SourcePage/SourcesQueries";
import Heading from "components/Elements/Heading.js";

const SourceCreateContainer = () => {
  const [sourcesCreate, { loading }] = useMutation(CREATE_SOURCE, {
    client,
    variables: {
      tenantID: parseInt(localStorage.defaultTenantID),
    },
  });

  return (
    <div className="container-wrapper">
      <div className="container-fluid">
        <main className="container-main">
          <Link to="/settings/sources">
            {" "}
            <i className="fas fa-chevron-circle-left" /> Back
          </Link>

          <Heading size={3} className={"mb-4 mt-4"}>
            Create New Source
          </Heading>

          <div className="row">
            <div className="col-6">
              <Formik
                initialValues={{
                  name: "",
                }}
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={AddSourceValidationSchema}
                onSubmit={async (
                  values,
                  { setSubmitting, setStatus, resetForm }
                ) => {
                  setStatus(undefined);

                  const results = await sourcesCreate({
                    variables: { ...values },
                  });
                  if (results.data.sourcesCreate) {
                    resetForm();
                    setStatus({
                      confirmation: `Source ${values.name}  has been created`,
                    });
                    setSubmitting(false);
                  }
                }}
              >
                {({ errors, status, touched, isSubmitting }) => (
                  <Form>
                    {status && status.confirmation && (
                      <div className="alert alert-success" role="alert">
                        {status.confirmation}
                      </div>
                    )}

                    <div className="form-group">
                      <label htmlFor="name">Source Name</label>
                      <Field
                        id="name"
                        type="text"
                        name="name"
                        placeholder="Source Name"
                        className="form-control"
                      />

                      {status && status.name ? (
                        <div className="invalid-feedback d-block">
                          {status.name}
                        </div>
                      ) : (
                        errors.name &&
                        touched.name && (
                          <div className="invalid-feedback d-block">
                            {errors.name}
                          </div>
                        )
                      )}
                    </div>

                    <div className="form-group">
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {loading ? "Adding New Source..." : "Add Source"}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default SourceCreateContainer;
